import { useQuery } from '@apollo/client';
import { GET_COMPANY_AND_CONFIG } from '../graphql/queries';

interface Company {
  publicId: string;
  name: string;
  telegramBotUrl?: string | null;
}

interface WidgetConfig {
  headerText?: string | null;
  headerSubtitle?: string | null;
  privacyPolicyUrl?: string | null;
  termsOfServiceUrl?: string | null;
  greeting?: string | null;
  knownUserGreeting?: string | null;
}

interface CompanyAndConfigResult {
  companies: Company[];
  widgetConfig: WidgetConfig | null;
}

interface CompanyInfo {
  name?: string;
  headerText?: string;
  headerSubtitle?: string;
  telegramBotUrl?: string;
  privacyPolicyUrl?: string;
  termsOfServiceUrl?: string;
  greeting?: string;
  knownUserGreeting?: string;
}

/**
 * Hook to fetch company info and widget config for the widget
 */
export function useCompany(): CompanyInfo {
  const { data } = useQuery<CompanyAndConfigResult>(GET_COMPANY_AND_CONFIG);
  const company = data?.companies?.[0];
  const widgetConfig = data?.widgetConfig;
  return {
    name: company?.name,
    headerText: widgetConfig?.headerText || undefined,
    headerSubtitle: widgetConfig?.headerSubtitle || undefined,
    telegramBotUrl: company?.telegramBotUrl || undefined,
    privacyPolicyUrl: widgetConfig?.privacyPolicyUrl || undefined,
    termsOfServiceUrl: widgetConfig?.termsOfServiceUrl || undefined,
    greeting: widgetConfig?.greeting || undefined,
    knownUserGreeting: widgetConfig?.knownUserGreeting || undefined,
  };
}
